export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_CURRENCY_SYMBOL = '$';
export const USD_THOUSANDS = 'USD ($) THOUSANDS';
export const USD_MILLIONS = 'USD ($) MILLIONS';
export const THOUSANDS = 'THOUSANDS';
export const MILLIONS = 'MILLIONS';
export const REGULAR_UNIT = '';
export const THOUSANDS_UNIT = 'THOUSANDS';
export const MILLIONS_UNIT = 'MILLIONS';
